var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"map",style:({width: _vm.width + '%', height: _vm.height + 'px'}),attrs:{"id":"map"}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }